import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { variables } from '../variables';

@customElement('apt-labeled-tag')
export class AptLabeledTag extends LitElement {
  @property({ type: String }) color = 'default';

  static override get styles() {
    return [
      variables,
      css`
        :host {
          font-size: 0.8em;
          color: white;

          --default: gray;
        }

        span {
          padding: 2px 5px;
          border-radius: 8px;
          margin-left: 8px;
        }
      `,
    ];
  }

  override render() {
    return html`<span
      style="background-color: var(--${this.color})"
      data-test-selector="labeled-tag"
    >
      <slot></slot>
    </span>`;
  }
}
